export default __webpack_public_path__ + "static/media/options.01f8b799.svg";